export default "__VITE_ASSET__BZwf3B4g__"